import { useUrlSearch } from "../../../../../hooks/useUrlSearch";
import { useGetStoresMappingList } from "../../../../../hooks/api/queries/useMarketPlace";

export const useAllConnections = () => {
  const { queries, search, filterBySearch, gotoPage } = useUrlSearch();

  const { data: storesMappingList, isLoading } = useGetStoresMappingList({
    queries,
    queryParams: { marketplace_type: "CHOWDECK" },
  });

  return {
    isLoading,
    search,
    storesMappingList: storesMappingList?.data || [],
    metaDetails: storesMappingList?.meta || {},
    gotoPage,
    filterBySearch,
  };
};
